import { gql, useQuery, QueryHookOptions } from '@apollo/client';

export const query = gql`
  query HiveUsers(
    $hiveId: ID!
    $pageSize: Int!
    $page: Int!
    $startDate: DateTime
    $endDate: DateTime
  ) {
    hiveUsers(
      hiveId: $hiveId
      pageSize: $pageSize
      page: $page
      startDate: $startDate
      endDate: $endDate
    ) {
      id
      firstName
      lastName
      userName
      password
      points
      numberOfGames
      totalTime
      allowedHiveGames
    }
  }
`;

export interface RequestType {
  hiveId: string;
  pageSize: number;
  page: number;
  startDate?: string;
  endDate?: string;
}

export interface HiveUserType {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  userName: string;
  password?: string | null;
  points?: number | null;
  numberOfGames?: number | null;
  totalTime?: number | null;
  allowedHiveGames?: string[] | null;
}

export interface QueryType {
  hiveUsers: HiveUserType[];
}

export function useHiveUsersQuery(
  request: RequestType,
  options?: QueryHookOptions<QueryType, RequestType>,
) {
  return useQuery<QueryType, RequestType>(query, {
    variables: request,
    ...options,
  });
}
